import { render } from "./VtoHeaderLabel.vue?vue&type=template&id=0193c31e"
import script from "./VtoHeaderLabel.vue?vue&type=script&lang=js"
export * from "./VtoHeaderLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__